import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CatalogItemViewMode, SalesRepCatalogItem } from 'src/app/acumatica/EntityServices/SalesRepCatalog.service';
import { AppConfig } from 'src/app/app-config.service';
import { QuantityInputComponent } from 'src/app/common/quantity-input/quantity-input.component';
import { MayerFabricsService } from 'src/app/services/mayer-fabrics.service';

@Component({
  selector: 'rep-order-item',
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.css']
})
export class RepOrderItemComponent {
  constructor(private mayerfabrics: MayerFabricsService) { }

  LifeCycleColor = this.mayerfabrics.LifeCycleColor;
  LifeCycleContrastColor = this.mayerfabrics.LifeCycleContrastColor;

  @ViewChild('quantityInput') quantityInputField!: QuantityInputComponent;
  @Input() viewMode!: CatalogItemViewMode;
  @Input() item!: SalesRepCatalogItem;
  @Input() qty: number | null | undefined;

  @Output() onQtyChange = new EventEmitter<number | null>();
  @Output() onNonNumericInput = new EventEmitter<string>();

  get imageURL(): string {
    return `${AppConfig.settings.LiquiFire.ImageServer}/item/${this.item.InventoryID.substring(1)}/image/thumbnail?size=40&quality=60`;
  }
  get imageCardURL(): string {
    // https://images.mayerfabrics.com/product/AS/card/thumbnail
    return `${AppConfig.settings.LiquiFire.ImageServer}/product/${this.item.PatternClass}/card/thumbnail?size=40&quality=60`;
  }
  get displayAsGrid(): boolean { return this.viewMode == CatalogItemViewMode.grid; }
  get displayAsList(): boolean { return this.viewMode == CatalogItemViewMode.list; }

  updateQuantity(item: SalesRepCatalogItem, qty: number | null) { this.onQtyChange.emit(qty); }

  public focus() { this.quantityInputField.focus(); }
}
